import React from 'react';
import { IconCard } from '../../../components';

import './style.scss';


const ThemeMenuFeaturedBlock = ({ entity }) => {
  const title = entity.getIn(['field_title', 0, 'value']);
  const link = entity.getIn(['field_link', 0, 'alias'], entity.getIn(['field_link', 0, 'uri']));
  const description = entity.getIn(['field_description', 0, 'processed']);

  return (
    <div className='ThemeMenuFeaturedBlock'>
      <IconCard
        title={title}
        description={description}
        href={link}
        richText
      />
    </div>
  );
};

export default ThemeMenuFeaturedBlock;
